<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6">
          <h5>Hostel Monthly Attendance Report</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row mb-3">
          <!-- Hostel Filter -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedHostel"
              placeholder="Filter by Hostel"
              style="width: 100%"
              allowClear
              @change="handleHostelChange"
            >
              <a-select-option v-for="h in hostels" :key="h.id" :value="h.id">
                {{ h.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Event -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedEventId"
              placeholder="Select Event"
              style="width: 100%"
              @change="handleEventChange"
            >
              <a-select-option v-for="event in filteredEvents" :key="event.id" :value="event.id">
                {{ event.name }}
                <small class="text-muted" v-if="event.hostel_id">({{ getHostelName(event.hostel_id) }})</small>
                <small class="text-muted" v-else>(Global)</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Date Range -->
          <div class="col-md-5 col-12 mb-2">
            <a-range-picker
              size="large"
              style="width: 100%"
              v-model="dateRange"
              :format="dateFormat"
              :disabled-date="disabledDate"
              @change="handleDateRangeChange"
            />
          </div>
        </div>

        <!-- Report Table Component -->
        <div class="card">
          <div class="card-body">
            <hostel-report-table
              v-if="reportData"
              :loading="loading"
              :data="reportData.data || []"
              :eventInfo="reportData.hostel_event"
              :startDate="reportData.start_date"
              :endDate="reportData.end_date"
              :totalDays="reportData.total_days"
            />
            <div v-else-if="!loading" class="text-center py-5">
              <a-empty description="Select an event and date range to generate report" />
            </div>
            <a-spin v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HostelReportTable from '@/components/hostel/manage/hostel-attendance/ReportTable'

export default {
  name: 'HostelMonthlyAttendanceReport',
  components: {
    HostelReportTable,
  },
  data() {
    return {
      loading: false,
      dateFormat: 'DD-MM-YYYY',

      hostels: [],
      events: [],
      selectedHostel: undefined,
      selectedEventId: undefined,
      dateRange: [moment().startOf('month'), moment()],

      reportData: null,
    }
  },
  computed: {
    filteredEvents() {
      if (!this.selectedHostel) {
        return this.events
      }
      return this.events.filter(e => e.hostel_id === null || e.hostel_id === this.selectedHostel)
    },
  },
  mounted() {
    this.fetchInitialData()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    fetchInitialData() {
      Promise.all([
        this.$http.get('/api/hostel'),
        this.$http.get('/api/hostel/event/all'),
      ])
        .then(([hostelsRes, eventsRes]) => {
          this.hostels = hostelsRes.data.data
          this.events = eventsRes.data.data || eventsRes.data
        })
    },
    getHostelName(hostelId) {
      const h = this.hostels.find(h => h.id === hostelId)
      return h ? h.name : ''
    },
    handleHostelChange(value) {
      this.selectedHostel = value || undefined
      if (this.selectedEventId) {
        const eventStillValid = this.filteredEvents.some(e => e.id === this.selectedEventId)
        if (!eventStillValid) {
          this.selectedEventId = undefined
          this.reportData = null
        }
      }
    },
    handleEventChange() {
      if (this.selectedEventId && this.dateRange && this.dateRange.length === 2) {
        this.fetchReport()
      }
    },
    handleDateRangeChange() {
      if (this.selectedEventId && this.dateRange && this.dateRange.length === 2) {
        this.fetchReport()
      }
    },
    fetchReport() {
      if (!this.selectedEventId || !this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('Please select an event and date range.')
        return
      }
      this.loading = true
      this.$http.get('/api/hostel/attendance/report', {
        params: {
          hostel_event_id: this.selectedEventId,
          start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        },
      })
        .then(({ data }) => {
          this.reportData = data
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
